function DetermineSlugLocale(fullSlug) {
  if(`${fullSlug}`.startsWith("fr")) {
    return "fr"
  }
  
  return "en"
}

export { DetermineSlugLocale }